export const DEFAULT_RSS_FEED_URL = "https://d1eo04duocy6ev.cloudfront.net/rss/feeds"

export const DevActionTypes = {
    SET_IS_DEV_MODE_ENABLED: "@@dev/SET_IS_DEV_MODE_ENABLED",
    SET_IS_NEW_UI_ENABLED: "@@dev/SET_IS_NEW_UI_ENABLED",
    SET_IS_INTERNAL_MODE_ENABLED: "@@dev/SET_IS_INTERNAL_MODE_ENABLED",
    SET_IS_ALPHA_MODE_ENABLED: "@@dev/SET_IS_ALPHA_MODE_ENABLED",
    SET_IS_FORCE_FREE_MODE: "@@dev/SET_IS_FORCE_FREE_MODE",
    SET_IS_TESTING_INSTRUMENT_SETTINGS: "@@dev/SET_IS_TESTING_INSTRUMENT_SETTINGS",
    // Dev/QA override to exercise SMRT Link Lite behavior against a non-Lite server.
    SET_IS_SMRTLINK_LITE_ENABLED: "@@dev/SET_IS_SMRTLINK_LITE_ENABLED",
    SET_RSS_FEED_URL: "@@dev/SET_RSS_FEED_URL",
    // TEMPORARY (dev/QA): pause delivery polling so injected fixtures are not
    // overwritten by the next poll. Remove with the in-app-comms dev tooling.
    SET_IS_IN_APP_COMMS_POLLING_PAUSED: "@@dev/SET_IS_IN_APP_COMMS_POLLING_PAUSED",
}

export interface DevState {
    isDevModeEnabled: boolean
    isNewUIEnabled: boolean
    isInternalModeEnabled: boolean
    isAlphaModeEnabled: boolean
    isDebugFreeMode: boolean
    isTestingInstrumentSettings: boolean
    // Dev/QA override forcing SMRT Link Lite mode on, regardless of the server's
    // apiFlags.isSmrtLinkLite, so Lite-only UI behavior can be tested locally.
    isSmrtLinkLiteEnabled: boolean
    rssFeedUrl: string
    // TEMPORARY (dev/QA): when true, delivery polling is suppressed so injected
    // fixtures persist. See SET_IS_IN_APP_COMMS_POLLING_PAUSED.
    isInAppCommsPollingPaused: boolean
}
